/**
 * Get the width of the scrollbar
 * @returns {number}
 * */
const getScrollbarWidth = () => window.innerWidth - document.documentElement.clientWidth;

/**
 * this function is used to prevent background scrolling when the modal is open
 * @returns {void}
 * */
export const setBodyStylesOnModalOpen = () => {
  // When the modal is shown, we want a fixed body
  const { scrollY } = window;
  const scrollbarWidth = getScrollbarWidth();
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.width = '100%';
  document.body.style.paddingRight = `${scrollbarWidth}px`;
};

/**
 * this function is used to reset the body style when the modal is closed
 * @returns {void}
 * */
export const setBodyStylesOnModalClose = () => {
  // When the modal is hidden, we want to remain at the top of the scroll position
  const scrollY = document.body.style.top;
  const bodyScrollPosition = parseInt(scrollY || '0', 10) * -1;
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  document.body.style.paddingRight = '';
  window.scrollTo(0, bodyScrollPosition);
};
